import React from 'react';
import { Box, IconButton } from '@wix/design-system';
import { More } from '@wix/wix-ui-icons-common';
import { observer } from 'mobx-react-lite';

export const CollectionActionsBar = observer(() => {
  return (
    <Box>
      <Box padding="SP1">
        <IconButton skin="standard" priority="secondary">
          <More />
        </IconButton>
      </Box>
    </Box>
  );
});
